
import React from 'react';
import { ContentType } from './types';

interface ContentTypeSelectorProps {
  contentTypes: ContentType[];
  selectedType: string | null;
  onSelectType: (typeId: string) => void;
}

const ContentTypeSelector: React.FC<ContentTypeSelectorProps> = ({ 
  contentTypes, 
  selectedType, 
  onSelectType 
}) => {
  return (
    <div>
      <h3 className="text-sm font-medium mb-2">Select Content Type</h3>
      <div className="grid grid-cols-1 gap-2">
        {contentTypes.map((type) => (
          <div 
            key={type.id}
            className={`p-3 rounded-md border cursor-pointer transition-colors flex items-center gap-3 ${
              selectedType === type.id 
                ? 'bg-purple-500/10 border-purple-500/50' 
                : 'bg-muted/30 border-transparent hover:bg-muted/50'
            }`}
            onClick={() => onSelectType(type.id)}
          >
            <div className={`p-2 rounded-full ${
              selectedType === type.id
                ? 'bg-purple-500/20 text-purple-500'
                : 'bg-muted text-muted-foreground'
            }`}>
              {type.icon}
            </div>
            <div>
              <h4 className="font-medium">{type.name}</h4>
              <p className="text-xs text-muted-foreground">{type.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ContentTypeSelector;
